import { Search } from "lucide-react";

import { Input } from "@/app/admin/_common/ui/input";

export default function ChecklistsToolbar({
  search,
  onSearchChange,
}: {
  search: string;
  onSearchChange: (value: string) => void;
}) {
  return (
    <div className="flex flex-wrap items-center gap-2 px-3 md:px-0">
      <div className="relative max-w-[420px] flex-1">
        <div className="pointer-events-none absolute inset-y-0 left-3 flex items-center">
          <Search className="size-3.5 text-muted-foreground" />
        </div>
        <Input
          type="search"
          placeholder="Search name or description…"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="h-[30px] pl-9 text-[12.5px]"
          aria-label="Search checklist templates"
        />
      </div>
    </div>
  );
}
